import React from 'react'
import {PaymentConfig} from '../../../../components/PaymentConfig/PaymentConfig'

export interface PaymentModalProps {
  totalPayable: number
  onClose: () => void
  onConfirm: () => Promise<void>
  disabled: boolean
  includeOldRecurrence?: boolean
  hideRecurrence?: boolean
  recurrenceMaxInstallments?: number
}

export const PaymentModal: React.FC<PaymentModalProps> = ({
  totalPayable,
  onClose,
  onConfirm,
  disabled,
  includeOldRecurrence,
  hideRecurrence,
  recurrenceMaxInstallments,
}) => {
  return (
    <>
      <div className='modal fade show d-flex' id='kt_modal_change_Payment'>
        <div className='modal-dialog modal-dialog-centered' style={{minWidth: '80%'}}>
          <div className='modal-content'>
            <div className='modal-body'>
              <PaymentConfig
                totalPayable={totalPayable}
                includeOldRecurrence={includeOldRecurrence}
                hideRecurrence={hideRecurrence}
                recurrenceMaxInstallments={recurrenceMaxInstallments}
              />
            </div>

            <div className='modal-footer d-flex justify-content-between w-100'>
              <button onClick={onClose} type='button' className='btn btn-secondary'>
                Cancelar
              </button>
              <button
                onClick={onConfirm}
                type='button'
                className='btn btn-danger'
                disabled={disabled}
              >
                Cobrar
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className='modal-backdrop fade show'></div>
    </>
  )
}
